var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobProfileViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.6875C14.2568 4.6875 13.0645 5.18136 12.1854 6.06044C11.3064 6.93951 10.8125 8.1318 10.8125 9.375C10.8125 10.6182 11.3064 11.8105 12.1854 12.6896C13.0645 13.5686 14.2568 14.0625 15.5 14.0625C16.7432 14.0625 17.9355 13.5686 18.8146 12.6896C19.6936 11.8105 20.1875 10.6182 20.1875 9.375C20.1875 8.1318 19.6936 6.93951 18.8146 6.06044C17.9355 5.18136 16.7432 4.6875 15.5 4.6875ZM10.5 16.5625C9.2568 16.5625 8.06451 17.0564 7.18544 17.9354C6.30636 18.8145 5.8125 20.0068 5.8125 21.25V22.735C5.8125 23.6775 6.495 24.48 7.425 24.6313C12.7725 25.505 18.2275 25.505 23.575 24.6313C24.0251 24.558 24.4345 24.327 24.7299 23.9796C25.0253 23.6322 25.1875 23.191 25.1875 22.735V21.25C25.1875 20.0068 24.6936 18.8145 23.8146 17.9354C22.9355 17.0564 21.7432 16.5625 20.5 16.5625H20.075C19.8438 16.5625 19.6138 16.6 19.395 16.67L18.3125 17.0238C16.4849 17.6203 14.5151 17.6203 12.6875 17.0238L11.605 16.67C11.3858 16.5987 11.1567 16.5624 10.9262 16.5625H10.5Z",
    fill: "#5A189A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobProfileViolet);
export default __webpack_public_path__ + "static/media/mob-profile-violet.eea1364e81fbae0e85b708360cd2318f.svg";
export { ForwardRef as ReactComponent };